import { Footer, FooterMobile, HeaderB2B, HeaderB2BMobile } from 'components';
import { SepekanKVBanner } from 'assets/images';
import styles from './webform.module.css';
import { useNavigate, useParams } from 'react-router-dom';
import { useEffect } from 'react';
import { Helmet } from 'react-helmet';

const Page = ({ isMobile = false }) => {
  const navigate = useNavigate();
  const { interest = 'rental' } = useParams();

  useEffect(() => {
    // Check if the previous page was from /saya-mau-electrum/:interest
    const referrer = document.referrer;
    if (!referrer || !referrer.includes('/saya-mau-electrum/')) {
      // If not, redirect to the main webform page (or a default interest page)
      navigate(`/saya-mau-electrum/${interest}`, { replace: true });
    }
  }, []);

  const pageMeta = {
    title: 'Form Berhasil Dikirim - Electrum',
    description: 'Terima kasih telah mengisi formulir. Tim kami akan segera menghubungi Anda.',
    keywords: 'electrum, success, form submitted, terima kasih',
  };

  return (
    <div>
      <Helmet>
        <title>{pageMeta.title}</title>
        <meta name="title" content={pageMeta.title} />
        <meta name="description" content={pageMeta.description} />
        <meta name="keywords" content={pageMeta.keywords} />
        <meta property="og:title" content={pageMeta.title} />
        <meta property="og:description" content={pageMeta.description} />
        <link rel="canonical" href={`https://electrum.id/saya-mau-electrum/${interest}/success`} />
      </Helmet>

      {isMobile ? <HeaderB2BMobile /> : <HeaderB2B />}

      <div
        className={styles['webform-container']}
        style={{
          textAlign: 'center',
          minHeight: '480px',
        }}
      >
        {/* SEPEKAN BANNER */}
        <div style={{ width: '100%', marginBottom: '2rem' }}>
          <img
            loading="lazy"
            alt="sepekan-banner"
            src={SepekanKVBanner}
            style={{ width: '100%', borderRadius: '1.5rem', cursor: 'pointer' }}
          />
        </div>
        <h1
          style={{
            fontFamily: 'Gilroy-Bold',
          }}
        >
          Form telah berhasil dikirim
        </h1>
        <div
          style={{
            fontFamily: 'Gilroy-light',
          }}
        >
          Terima kasih. Kami akan segera menghubungi Anda.
        </div>
      </div>

      {isMobile ? <FooterMobile /> : <Footer />}
    </div>
  );
};

export default Page;
